import { ContactPathsEnum } from 'modules/contactPage/routes';
import { useSidePopout } from 'modules/layout';
import { Button, ButtonType, Flex } from 'modules/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

export const FooterButtons: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { closePopout } = useSidePopout();

  const redirectToContactForm = () => {
    closePopout();
    history.push({
      pathname: ContactPathsEnum.contactPage,
    });
  };
  return (
    <Flex margin="4rem 0 0 0">
      <Button
        type={ButtonType.Text}
        text={t('landingPage.forgottenPasswordForm.customerSupport')}
        onClick={redirectToContactForm}
      />
    </Flex>
  );
};
